<template>
  <UPopover
    :content="{
      align: 'start',
    }"
  >
    <UButton variant="ghost" color="neutral" size="lg" class="gap-2 px-2">
      <img v-if="currentLang.icon" :src="currentLang.icon as string" alt="Language Icon" class="w-5 h-5 rounded-full object-cover" />
      <!-- <span class="hidden md:inline uppercase">{{ currentLang.shortName }}</span> -->
      <Icon name="i-heroicons-chevron-down" class="w-4 h-4" />
    </UButton>

    <template #content="{close}">
      <div class="p-2 space-y-1 min-w-[200px]">
        <div 
          v-for="locale in locales" 
          :key="locale.code"
          @click="setLocale(locale.code); close()"
          class="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded cursor-pointer"
        >
          <img v-if="locale.icon" :src="locale.icon as string" alt="Language Icon" class="w-5 h-5 rounded-full object-cover" />
          <span class="text-sm">{{ locale.name }}</span>
        </div>
      </div>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
const { locales, setLocale, locale } = useI18n()

const currentLang = computed(() => {
  return locales.value.find(l => l.code === locale.value)!
})
</script>